<section id="wifi-onboard-connect" class="wifi-onboard-connect modal" data-modal="wifi-onboard-connect" style="display: block !important">
  <app-error *ngIf="showErrorMsg"></app-error>
  <div class="wrapper wrapperIpad">
    <div class="modal-body">
      <header>
        <button id="activate-close" type="button" class="modal-close" data-modal-close="wifi-onboard-connect" (click)="closeActivateOverlay()"
          tabindex="0" [attr.aria-label]="('close' | translate)">×</button>
        <div class="wifi-icon">

        </div>
        <h3 id="activate-header" class="activate-header">{{'wifiLogin.header' | translate}}</h3>
      </header>
      
      <div class="activate-content" [ngClass]="{'buyactivate-content':!showToggleButton, 'buyactivate-content-charter': showToggleButton && isCharterFlight}">
        <div class="toggle-btn-wrap" [ngClass]="{'pad-b-10': !showToggleButton, 'toggle-no-show': isCharterFlight}">

          <div class="row-block btn-wrapper my-trip-tab">
            <div class="toggle-button large-4 medium-6 small-12" *ngIf="showToggleButton && !isCharterFlight">
              <button id="bookRefAc" class="btn small" type="button" [ngClass]="{'active': showBokrefFileds}" (click)="toggleButtonChange('bref')"
                tabindex="0" attr.aria-label="{{(bookAndEuro)?('wifiLogin.informationText' | translate)+('wifiLogin.type.pnr' | translate):''}}"
                attr.aria-pressed="{{(showBokrefFileds)?'true':'false'}}" (keydown.tab)="keyEvent($event, '#eurobonusAcc')">{{'wifiLogin.type.pnr' | translate}}</button>
              <button id="eurobonusAcc" class="btn small" type="button" [ngClass]="{'active': showEuroBonusFileds}" (click)="toggleButtonChange('eb')"
                tabindex="0" attr.aria-label="{{'wifiLogin.type.ebNumber' | translate}}" attr.aria-pressed="{{(showEuroBonusFileds)?'true':'false'}}">{{'wifiLogin.type.ebNumber' | translate}}</button>
            </div>
          </div>
          <div class="clear"></div>
        </div>

        <div class="mrgn-t-2" *ngIf="!showDisabledLoginFields && showEuroBonusFileds">
          <p class="wifi-notification-eurobonus">If you’re in SAS Go or Plus or have a EuroBonus Silver or Member status, use your booking reference to log in.</p>
        </div>
        <div class="wifi-eligibility-text mrgn-t-2" *ngIf="showEBforPointsBuy">
          <p class="wifi-notification-eurobonus">Please login using your EB Profile credentials to continue</p>
        </div>
        <div class="new-eb-login-btn text-center" *ngIf="!showDisabledLoginFields && showEuroBonusFileds">
          <button class="btn medium primary connect-wifi landing-connect" (click)="newEbLogin()" *ngIf="!sessionIdExists">Login to EuroBonus</button>
          <button class="btn medium primary connect-wifi landing-connect" *ngIf="sessionIdExists" (click)="newEBLoginActivate()">Connect to WiFi</button>
        </div>
        <div class="new-eb-login-btn text-center" *ngIf="showEBforPointsBuy">
          <button class="btn medium primary connect-wifi landing-connect" (click)="newEbLogin()" *ngIf="!sessionIdExists">Login to EuroBonus</button>
          <button class="btn medium primary connect-wifi landing-connect" *ngIf="sessionIdExists" (click)="newEBLoginActivate()">Connect with EuroBonus</button>
        </div>
        <div class="activate-form" [ngClass]="{'activate-cahrter-form': isCharterFlight}">
          <app-pnr-login (formSubmit)="connectToWifiPnr()" *ngIf="showBokrefFileds && !showEBforPointsBuy"></app-pnr-login>
          <!-- <app-eb-login (connectToWifi)="connectToWifiLogin()" class="hide-element" [ngClass]="{'show-element': ((!showDisabledLoginFields && showEuroBonusFileds) || showEBforPointsBuy)}"
            *ngIf="(showToggleButton && !isCharterFlight) || showEBforPointsBuy"></app-eb-login> -->
          
          <app-disabled-login-form (openSasTnc)="openSasTnC()" *ngIf="showDisabledLoginFields && showEuroBonusFileds"></app-disabled-login-form>
        </div>
        <div class="clear"></div>        

      </div>
      <div class="wifi-notification mrgn-t-30 text-info">
        <p class="text-white wifi-disclaimer text-padding" *ngIf="!showEBforPointsBuy">{{'wifi.disclaimer' | translate}}</p>
        <p class="text-white wifi-disclaimer text-padding" *ngIf="showEBforPointsBuy">The information you enter above will be used to verify your EuroBonus account.</p>
        <p class="text-white wifi-disclaimer">{{'wifi.disclaimer.text' | translate}}</p>
      </div>
      <!-- modal content end -->
    </div>
    <!-- modal body end -->
  </div>
</section>
<!-- modal end -->
